import { version } from '@/root/VERSION'
import axios from 'axios'

export { axios as axiosPkg }

export const FE_HEADER_VERSION = 'x-fe-version'

/**
 * Central axios instance for all frontend HTTP requests.
 */
const axiosInstance = axios.create()
let isReloading = false

const resetIsReloading = () => {
    setTimeout(() => {
        isReloading = false
    }, 5_000)
}

// Request interceptor which adds the version header
axiosInstance.interceptors.request.use((config) => {
    // add version header to the request - for POST we have to add it in the call itself
    config.headers[FE_HEADER_VERSION] = version
    return config
})

// Response interceptor for the reload
axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 418 && !isReloading) {
            isReloading = true

            try {
                console.log('Reload required')
                // reload the page if the version is outdated
                window.location.reload()
            } catch (e) {
                console.error('Reload failed:', e)
                resetIsReloading() // reset on error
            }

            // security-reset - if reload fails
            resetIsReloading()
        }
        return Promise.reject(error)
    },
)

export default axiosInstance

export const getVersionForHeader = () => {
    const header = getCustomHeader(FE_HEADER_VERSION, version)
    return header
}

const getCustomHeader = (headerName: string, value: string) => {
    return { [headerName]: value }
}
